import {Lang} from 'yougile-lang'

import {cn} from '@containers/html-utils'
import {Context, UserType} from './types'

export const getTitle = (type: UserType, name?: string): string | undefined => {
  switch (type) {
    case 'normal':
    case 'not-registered':
    case 'disallowed':
      return name
    case 'guest':
      return name ? `${name} (${Lang.msg.share.guest})` : Lang.msg.share.guest
    default:
      throw new Error(`Unknown type: ${type}`)
  }
}

export const getText = (context: Context): string => {
  switch (context) {
    case 'override':
      return ''
    case 'ui':
      return cn('font-semibold', 'text-12', 'leading-4')
    default:
      throw new Error(`Unknown context: ${context}`)
  }
}

export const getNameColor = (type: UserType, context: Context): string => {
  switch (context) {
    case 'override':
      return 'text-inherit'
    case 'ui':
      switch (type) {
        case 'normal':
        case 'guest':
          return 'text-primary'
        case 'disallowed':
          return 'text-error'
        case 'not-registered':
          return 'text-placeholder'
        default:
          throw new Error(`Unknown type: ${type}`)
      }
    default:
      throw new Error(`Unknown context: ${context}`)
  }
}

export const getGuestColor = (context: Context): string => {
  if (context === 'override') {
    return ''
  }
  return 'text-placeholder'
}
